import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { BrutalButton, BrutalCard } from "@/components/Brutal";
import { useAuth } from "@/context/AuthContext";
import api, { formatError } from "@/lib/api";
import { toast } from "sonner";

export default function SetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/auth/set-password/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(formatError(e.response?.data?.detail) || "Ongeldige link"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Minstens 6 tekens");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/set-password", { token, password });
      localStorage.setItem("doenies_token", data.session_token);
      await refresh();
      toast.success("Welkom bij Slackr! 🎉");
      navigate("/vandaag");
    } catch (e2) { toast.error(formatError(e2.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center p-5" data-testid="set-password-page">
      <div className="w-full max-w-md">
        <h1 className="font-head font-black text-4xl text-center mb-6">Slackr</h1>
        <BrutalCard>
          {error ? (
            <div className="text-center py-6" data-testid="set-password-error">
              <p className="font-head font-black text-xl">Oeps</p>
              <p className="text-brand-ink/60 font-semibold mt-1">{error}</p>
            </div>
          ) : !info ? (
            <div className="text-center py-6"><Loader2 className="w-8 h-8 mx-auto animate-spin" /></div>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <div className="flex items-center gap-2"><KeyRound className="w-5 h-5" strokeWidth={2.5} /><span className="font-head font-bold">Welkom, {info.name}!</span></div>
              <p className="text-sm text-brand-ink/60 font-semibold">Stel een wachtwoord in voor {info.email}.</p>
              <input data-testid="set-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Nieuw wachtwoord" className="w-full brutal-sm rounded-xl px-4 py-3 font-medium outline-none" />
              <BrutalButton data-testid="set-password-submit" type="submit" className="w-full" disabled={busy}>
                {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <KeyRound className="w-5 h-5" strokeWidth={2.5} />}Instellen & inloggen
              </BrutalButton>
            </form>
          )}
        </BrutalCard>
      </div>
    </div>
  );
}
